import React from 'react';

export const LoaderSkeletonChart = () => {
  return (
    <div className="flex-1 h-full flex flex-col" data-testid="skeleton">
      <div className="h-6 w-40 animate-pulse bg-gray-200 rounded mb-6"></div>
      <div className="flex flex-1 gap-1 w-full">
        <div className="py-4 h-[270px] w-6">
          <div className="h-full w-full animate-pulse bg-gray-200 rounded"></div>
        </div>
        <div className="flex flex-1 items-end h-[270px] p-2 gap-1 border-b border-l border-gray-300">
          <div className="flex-1 h-[186px]">
            <div className="h-full w-full animate-pulse bg-gray-200 rounded"></div>
          </div>
          <div className="flex-1 h-[156px]">
            <div className="h-full w-full animate-pulse bg-gray-200 rounded"></div>
          </div>
          <div className="flex-1 h-[86px]">
            <div className="h-full w-full animate-pulse bg-gray-200 rounded"></div>
          </div>
          <div className="flex-1 h-[56px]">
            <div className="h-full w-full animate-pulse bg-gray-200 rounded"></div>
          </div>
          <div className="flex-1 h-[116px]">
            <div className="h-full w-full animate-pulse bg-gray-200 rounded"></div>
          </div>
          <div className="flex-1 h-[76px]">
            <div className="h-full w-full animate-pulse bg-gray-200 rounded"></div>
          </div>
          <div className="flex-1 h-[89px]">
            <div className="h-full w-full animate-pulse bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
      <div className="pl-10 pr-4 h-6 w-full mt-1">
        <div className="h-full w-full animate-pulse bg-gray-200 rounded"></div>
      </div>
    </div>
  );
};

export const LoaderSkeletonTab = () => {
  return (
    <div className="w-1/5 min-w-72 flex flex-col gap-4">
      {new Array(3).fill(0).map((_, id) => (
        <div
          key={id}
          className="flex-1 w-full animate-pulse bg-gray-200 rounded min-h-[106px]"
        ></div>
      ))}
    </div>
  );
};
